import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import RaisedButton from 'material-ui/RaisedButton'
import { Card, CardText } from 'material-ui/Card'
import Header from '../../components/Header/Header'
import FileDetails from '../../components/Common/FileDetails'
import { uploadFile, chooseFile } from '../../actions/uploadcsv'
import { getFileDetails } from '../../lib/helper'

if (process.env.WEBPACK) {
  require('./UploadCSV.css')
}

const mapStateToProps = state => ({
  fileUploadData: state.fileUploadData,
  showMessage: state.showMessage
})

const mapDispatchToProps = dispatch => {
  return {
    uploadFile: bindActionCreators(uploadFile, dispatch),
    chooseFile: bindActionCreators(chooseFile, dispatch),
    dispatch
  }
}

class UploadCSV extends Component {
  constructor(props) {
    super(props)
    this.state = {
      file: null,
      wrongFile: true,
      fileDetails: null,
      chooseAFile: false
    }
    this.onChange = this.onChange.bind(this)
    this.fileUpload = this.fileUpload.bind(this)
    this.resetFile = this.resetFile.bind(this)
  }

  onChange(e) {
    const { chooseFile } = this.props
    chooseFile()
    const file = e.target.files[0]
    if (!file) {
      this.resetFile()
      this.setState({ wrongFile: true })
      return
    }
    const fileDetails = getFileDetails(file)
    const wrongFile =
      ['text/csv', 'application/vnd.ms-excel'].indexOf(file.type) === -1
    this.setState({ file, fileDetails, wrongFile })
  }

  resetFile() {
    this.setState({
      file: null,
      fileDetails: null,
      chooseAFile: false,
      wrongFile: true
    })
  }

  fileUpload() {
    const file = this.state.file
    if (file) {
      const { uploadFile } = this.props
      uploadFile(file)
    } else {
      this.setState({ chooseAFile: true })
    }
  }

  static getCard(message) {
    return (
      <Card>
        <CardText>{message}</CardText>
      </Card>
    )
  }

  getMessage = (finaName, uploaded) => {
    const message = uploaded ? (
      <div>
        File <strong>{finaName}</strong> uploaded successfully
      </div>
    ) : (
      <div>
        Some error occurred trying to upload <strong>{finaName}</strong>
      </div>
    )
    return UploadCSV.getCard(message)
  }

  render() {
    let statusMessage = this.state.file ? (
      <FileDetails file={this.state.file} />
    ) : (
      ''
    )

    let disableButton = false
    if (
      this.props.fileUploadData &&
      this.state.fileDetails &&
      this.props.showMessage
    ) {
      disableButton = true
      if (this.props.fileUploadData.error) {
        statusMessage = this.getMessage(this.state.fileDetails.name)
      } else {
        statusMessage = this.getMessage(this.state.fileDetails.name, true)
      }
    }

    if (statusMessage === '' && this.state.chooseAFile) {
      statusMessage = UploadCSV.getCard(
        <div>
          Please choose a <strong>file</strong> first!
        </div>
      )
    }

    const styles = {
      button: {
        margin: 12
      },
      exampleFileInput: {
        cursor: 'pointer',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        width: '100%',
        opacity: 0
      },
      error: {
        color: 'red'
      }
    }

    return (
      <div>
        <Header title='Upload CSV' {...this.props} />
        <div className='upload-file-wrap'>
          <RaisedButton
            label='Choose a CSV file'
            labelPosition='before'
            style={styles.button}
            containerElement='label'
          >
            <input
              type='file'
              style={styles.exampleFileInput}
              onClick={this.resetFile}
              onChange={this.onChange}
            />
          </RaisedButton>
          <div style={styles.button}>{statusMessage}</div>
          {this.state.file && this.state.wrongFile && (
            <div style={styles.error}>Please choose a CSV file!</div>
          )}
          <RaisedButton
            label='Upload CSV'
            primary
            disabled={this.state.wrongFile || disableButton}
            onClick={this.fileUpload}
          />
        </div>
      </div>
    )
  }
}

UploadCSV.propTypes = {
  showMessage: PropTypes.bool,
  chooseFile: PropTypes.func,
  uploadFile: PropTypes.func,
  fileUploadData: PropTypes.object
}

export default connect(mapStateToProps, mapDispatchToProps)(UploadCSV)



/** WEBPACK FOOTER **
 ** ./src/containers/UploadCSV/UploadCSV.js
 **/